import { IsDefined, MaxLength, IsNumberString, IsPositive, Validate } from 'class-validator';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { BrandsFieldValidator } from 'src/core/customValidator/brandFieldsValidator';

export class BrandDataService extends DataService<typeof Model.General.Logic.ViewModels.BrandItem, Model.General.Logic.ViewModels.BrandItem, BrandItem> {
	protected map(entity: Model.General.Logic.ViewModels.BrandItem): BrandItem {
		return new BrandItemModel(entity);
	}

	public static make(ctx?: any): BrandDataService {
		return new BrandDataService(ctx, ctx => ctx.Brands);
	}
	public add(defaultLanguage: string) {
		const entity = new Model.General.Logic.ViewModels.BrandItem();
		(entity as any).dynamicProperties = {
			email: undefined,
			phone: undefined,
			quoteNumberPrefix: '',
			translations: { [defaultLanguage]: '' }
		};
		return entity;
	}
}

export class BrandItemModel extends EntityModel<Model.General.Logic.ViewModels.BrandItem, BrandItem> implements BrandItem {

	@property<BrandItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	@Validate(BrandsFieldValidator)
	public dynamicProperties: {};

	@property<BrandItemModel>(o => o.entity.name, (o, value) => o.entity.name = value)
	@IsDefined({ message: 'name is required' })
	@MaxLength(128, { message: 'name is to long' })
	public name: string;

	@property<BrandItemModel>(o => o.entity.logo, (o, value) => o.entity.logo = value)
	public logo: Uint8Array;

	@property<BrandItemModel>(o => o.entity.footer, (o, value) => o.entity.footer = value)
	public footer: Uint8Array;
}




// WEBPACK FOOTER //
// ./src/app/general/brands/form/brand-form.data.ts